export const practitionerHub = {
  notifications: {
    updates: "Updates",
  },
  showMore: "Show more",
  emptyNotifications: {
    title: "You're all caught up",
    content: "Nothing needs your attention right now. Time to focus on patient care.",
  },
} as any;
